import { Fragment } from 'react';
import { Page } from '../theme/elements/Page';
import { Box, Stack, Typography } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { permissionEnums } from 'constants/permission.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import { getBankList } from 'state/reducers/global.reducer';
import WaitingMessage from 'components/WaitingMessage';
import { DigitalDepositBankAvailabilityTable } from 'sections/DigitalDepositBankAvailability/DigitalDepositBankAvailabilityTable';

const boxStyle = {
	maxWidth: 910,
	width: '100%',
	whiteSpace: 'pre-line',
	wordBreak: 'break-word',
	lineHeight: 1.6,
};

export const DigitalDepositBankAvailabilityApp = () => {
	const t = useAppSelector(selectTranslations);
	const bankList = useAppSelector(getBankList);
	const editPermission = hasPermission([permissionEnums.EDIT_SYSTEM_SETTINGS]);

	return (
		<Fragment>
			<Page>
				<Stack spacing={2} sx={{ marginBottom: '20px' }}>
					<Typography variant="pageTitle">{t('page.digital_deposit_bank_availability.title')}</Typography>
					<Box sx={boxStyle}>
						<Typography variant="boldBody1" sx={{ mb: 1 }}>
							{t('page.digital_deposit_bank_availability.subtitle')}
						</Typography>
						<Typography variant="body2" color="error.main">
							{t('page.digital_deposit_bank_availability.warning')}
						</Typography>
					</Box>
					{!bankList ? (
						<WaitingMessage />
					) : (
						editPermission && <DigitalDepositBankAvailabilityTable bankList={bankList} />
					)}
				</Stack>
			</Page>
		</Fragment>
	);
};
